module.exports = __webpack_public_path__ + "img/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-0.02f29efc.jpg";